import type React from "react";
import { motion } from "framer-motion";
import { Input } from "@/shared/components/atoms/Input";
import type { User } from "./types";
import {
  useLazyStripeSetupIntentQuery,
  usePaymentConfigQuery,
} from "@/app/payments/payments.api";
import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/app/app.store";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { PaymentForm } from "@/shared/components/organisms/PaymentForm";

interface PaymentSectionProps {
  user: User;
  handleChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => void;
}

const slideUp = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
};

export const PaymentSection: React.FC<PaymentSectionProps> = ({
  user,
  handleChange,
}) => {
  const currentUser = useSelector((state: RootState) => state.auth.user);

  const [stripeSetupIntent, stripeSetupIntentResult] =
    useLazyStripeSetupIntentQuery();
  const paymentConfigQuery = usePaymentConfigQuery({
    id: currentUser?.branch?.id,
  });

  const [fieldValue, setFieldValue] = useState({
    name: user.name || "",
    email: user.email || "",
    number_id: "",
    cabys: "",
  });

  const values = {
    name: fieldValue.name,
    email: fieldValue.email,
    number_id: fieldValue.number_id,
  };

  const errors = {
    name: "",
    email: "",
    number_id: "",
  };

  const touched = {
    name: false,
    email: false,
    number_id: false,
  };

  console.log("Stripe Public Key:", paymentConfigQuery?.data?.publicKeyPayment);
  console.log(
    "Stripe Client Secret:",
    stripeSetupIntentResult?.data?.clientSecret
  );
  console.log("currentUser?.branch?.id:", currentUser?.branch?.id);

  return (
    <div className="bg-white p-6 border-t border-purple-500/10">
      <h3 className="font-semibold text-gray-800 mb-4">Información de Pago</h3>

      {user.branch.gateway === "wompi" && (
        <motion.div variants={slideUp} className="space-y-4">
          <div className="flex justify-center mb-4">
            <motion.img
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
              src="https://wompi.com/assets/img/home/logo-wompi.svg"
              alt="Wompi"
              className="h-6"
            />
          </div>
          <div className="space-y-4">
            <Input
              label="Nombre en la Tarjeta"
              name="cardname"
              value={user.name}
              onChange={handleChange}
              required
            />
            <Input
              label="Correo Electrónico"
              name="cardemail"
              value={user.email}
              onChange={handleChange}
              type="email"
              required
            />
            <Input
              label="Número de Tarjeta"
              name="cardnumber"
              value=""
              onChange={handleChange}
              placeholder="4242 4242 4242 4242"
              required
            />
            <div className="grid grid-cols-2 gap-4">
              <Input
                label="Vencimiento (mm/aa)"
                name="expirationdate"
                value=""
                onChange={handleChange}
                placeholder="12/25"
                required
              />
              <Input
                label="Código de Seguridad"
                name="securitycode"
                value=""
                onChange={handleChange}
                placeholder="123"
                required
              />
            </div>
            <div className="hidden text-center text-yellow-600" id="text-alert">
              <p>Procesando su pago, por favor espere...</p>
            </div>
            <div className="hidden text-center text-red-600" id="text-error">
              <p>El pago falló. Por favor, inténtelo de nuevo.</p>
              <p className="error_custom"></p>
            </div>
          </div>
        </motion.div>
      )}

      {user.branch.gateway === "stripe" && (
        <motion.div variants={slideUp} className="space-y-4">
          <PaymentForm
            setFieldValue={setFieldValue}
            handleChange={handleChange}
            values={values}
            errors={errors}
            touched={touched}
          />
        </motion.div>
      )}
    </div>
  );
};
